import { render, staticRenderFns } from "./ModalPriceAdjustV2.vue?vue&type=template&id=06a2d8a4&scoped=true"
import script from "./ModalPriceAdjustV2.vue?vue&type=script&lang=js"
export * from "./ModalPriceAdjustV2.vue?vue&type=script&lang=js"
import style0 from "./ModalPriceAdjustV2.vue?vue&type=style&index=0&id=06a2d8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a2d8a4",
  null
  
)

export default component.exports